var map = {
	"./AWS-logo.jpg": 3870,
	"./Bluemix_logo.jpg": 23739,
	"./Cloud-Sigma-logo.jpg": 74078,
	"./Deutsche_Telekom-Logo.jpg": 91262,
	"./LOGO-WEB-ALIBABA-01.jpg": 51588,
	"./atman.png": 75707,
	"./aws_logo_smile.png": 90146,
	"./azure-logo.png": 97496,
	"./backblaze-logo-horiz.jpg": 33882,
	"./baidu-open-cloud-logo.png.jpg": 2826,
	"./citycloud.png": 40919,
	"./dunkel.png": 55502,
	"./exoscale.png": 43389,
	"./google_cloud_new.png": 20509,
	"./google_cloud_platform.jpg": 71612,
	"./ionos.png": 96103,
	"./leaseweb.png": 50629,
	"./microsoft_azure.jpg": 20467,
	"./orange.png": 52274,
	"./outscale.png": 46097,
	"./ovh-logo.jpg": 76203,
	"./ovh_logo.png": 47900,
	"./scaleway.png": 22093,
	"./ventus.png": 97491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77169;